<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 用户信息表格 -->
      <el-table :data="allUserList">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="账号" prop="UserNO" align="center"></el-table-column>
        <el-table-column label="名称" prop="UserName" align="center"></el-table-column>
        <el-table-column label="类型" prop="User_Type" align="center"></el-table-column>
        <el-table-column label="状态" prop="Is_Del" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="CreateTime" width="160" align="center">
          <template slot-scope="scope">
            {{ scope.row.CreateTime | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400px" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
            <el-button type="text" icon="el-icon-setting" size="mini" @click="showEditPwdDialog(scope)">修改密码</el-button>
            <el-button type="text" icon="el-icon-reload" size="mini" @click="resetPwd(scope)">重置密码</el-button>
            <el-button type="text" icon="el-icon-delete" size="mini" @click="removeUser(scope)">删除</el-button>
            <el-button type="text"  icon="el-icon-warning-outline" size="mini" @click="disableUser(scope)">禁用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 修改用户的会话框 -->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="20%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="80px">
        <el-form-item label="账号" prop="UserNO" required>
          <el-input v-model="editForm.UserNO"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="UserName" required>
          <el-input v-model="editForm.UserName"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="User_Type" required>
          <el-select v-model="editForm.User_Type" placeholder="请选择用户类型">
            <el-option
              v-for="item in userTypeList"
              :key="item.ID"
              :label="item.TypeName"
              :value="item.TypeIdentifying"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码的会话框 -->
    <el-dialog title="修改密码" :visible.sync="editPwdDialogVisible" width="20%" @close="editPwdDialogClose">
      <el-form :model="pwdList" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <el-form-item label="原密码" prop="oldPwd" required>
          <el-input v-model="pwdList.oldPwd" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd" required>
          <el-input v-model="pwdList.newPwd" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPwdAgain" required>
          <el-input v-model="pwdList.newPwdAgain" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editUserPwd()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            getTypeList1: {
                page: '1',
                limit: '10000',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            // 用户信息表
            allUserList: [],
            //  用户列表总条数
            total: 0,
            // 控制修改用户对话框的显示与隐藏
            editDialogVisible: false,
            // 控制修改用户密码对话框的显示与隐藏
            editPwdDialogVisible: false,
            // 用户表名
            tableName: 'main_user',
            // 用户类型表名
            tableName1: 'main_user_type',
            // 编辑用户信息的表单数据
            editForm: [],
            // 修改用户密码信息的表单数据
            editForm1: [],
            // 用户类型表
            userTypeList: [],
            // 修改密码信息表
            pwdList: {
                oldPwd: '',
                newPwd: '',
                newPwdAgain: ''
            },
            // 重置密码用户信息列表
            resetPwdUserList: [],
        }
    },
    created () {
        this.getAllUserList()
        this.getAllUserList1()
        this.getUserType()
    },
    methods: {
        //调用接口获取所有用户信息
        async getAllUserList () {
            const { data: res } = await this.$http.get('/User/UserSelectAll', { params: this.getTypeList })
            console.log(res.data)
            this.allUserList = res.data
            for (var i = 0; i < this.allUserList.length; i++) {
                if (this.allUserList[i].User_Type == 'E') {
                    this.allUserList[i].User_Type = '员工'
                }
                if (this.allUserList[i].User_Type == 'C') {
                    this.allUserList[i].User_Type = '客户'
                }
                if (this.allUserList[i].User_Type == 'S') {
                    this.allUserList[i].User_Type = '供应商'
                }
                if (this.allUserList[i].Is_Del == 'N') {
                    this.allUserList[i].Is_Del = '正常'
                }
                if (this.allUserList[i].Is_Del == 'Y') {
                    this.allUserList[i].Is_Del = '禁用'
                }
            }
        },
        //调用接口获取所有用户信息
        async getAllUserList1 () {
            const { data: res } = await this.$http.get('/User/UserSelectAll', { params: this.getTypeList1 })
            this.total = res.data.length
            this.resetPwdUserList = res.data
        },
        //监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getAllUserList()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            this.getTypeList.page = newPage
            this.getAllUserList()
        },
        // 调用接口删除用户
        async removeUser (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该信息, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/DeleteUser', params)
            console.log(res)
            if (res.code != 1) {
                return this.$message.error('删除失败！')
            } else {
                this.$message.success('删除成功！')
            }
            this.getAllUserList()
            this.getAllUserList1()
        },
        // 展示修改用户信息的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.editForm = res.data[0]
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        // 监听修改用户密码对话框的关闭事件
        editPwdDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        // 调用接口查询用户类型
        async getUserType () {
            let params = new URLSearchParams();
            params.append("page", this.getTypeList.page)
            params.append("limit", this.getTypeList1.limit)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.tableName1)
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params })
            console.log(res.data)
            this.userTypeList = res.data
        },
        // 调用接口修改用户信息
        async editUser () {
            // if (!valid) return
            let params = new URLSearchParams();
            params.append("ID", this.editForm.ID)
            params.append("UserNO", this.editForm.UserNO)
            params.append("UserName", this.editForm.UserName)
            params.append("Pwd", this.editForm.Pwd)
            params.append("Is_Del", this.editForm.Is_Del)
            params.append("sessionId", this.editForm.sessionId)
            params.append("User_Type", this.editForm.User_Type)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('13' + params)
            const { data: res } = await this.$http.post('/User/UpdateUser', params)
            console.log(res)
            if (res.code != 1) {
                return this.$$message.error('接口异常，修改失败！')
            } else {
                this.$message.success('修改用户信息成功！')
            }
            this.editDialogVisible = false
            this.getAllUserList()
            this.getAllUserList1()
        },
        // 展示修改用户密码的对话框
        async showEditPwdDialog (scope) {
            this.editPwdDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.editForm1 = res.data[0]
        },
        // 调用接口修改密码
        async editUserPwd () {
            // if (!valid) return
            if (this.editForm1.Pwd != this.pwdList.oldPwd) {
                return this.$message.error('原密码输入错误！')
            } else if (this.pwdList.newPwd != this.pwdList.newPwdAgain) {
                return this.$message.error('两次新密码输入不一致！')
            }
            let params = new URLSearchParams();
            params.append("ID", this.editForm1.ID)
            params.append("UserNO", this.editForm1.UserNO)
            // params.append("UserName", this.editForm.UserName)
            params.append("Pwd", this.pwdList.newPwd)
            params.append("Is_Del", this.editForm1.Is_Del)
            params.append("sessionId", this.editForm1.sessionId)
            params.append("User_Type", this.editForm1.User_Type)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/UpdatePWD', params)
            console.log(res)
            if (res.code != 1) {
                return this.$$message.error('接口异常，修改失败！')
            } else {
                this.$message.success('修改密码成功！')
            }
            this.editPwdDialogVisible = false
            this.getAllUserList()
            this.getAllUserList1()
        },
        // 调用接口重置密码
        async resetPwd (scope) {
            const confirmResult = await this.$confirm(
                '此操作将重置该密码, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)
            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消重置！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("UserNO", scope.row.UserNO)
            // params.append("UserName", this.editForm.UserName)
            params.append("Pwd", scope.row.Pwd)
            params.append("Is_Del", scope.row.Is_Del)
            params.append("sessionId", scope.row.sessionId)
            params.append("User_Type", scope.row.User_Type)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log(158 + params)
            const { data: res } = await this.$http.post('/User/ResetPWD', params)
            console.log(res)
            if (res.code != 1) {
                return this.$message.error('重置失败！')
            } else {
                this.$message.success('重置成功！')
            }
            this.getAllUserList()
            this.getAllUserList1()
        },
        // 调用接口禁用用户
        async disableUser (scope) {
            const confirmResult = await this.$confirm(
                '此操作将禁用该用户, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)
            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消禁用！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("UserNO", scope.row.UserNO)
            // params.append("UserName", this.editForm.UserName)
            params.append("Pwd", scope.row.Pwd)
            params.append("Is_Del", scope.row.Is_Del)
            params.append("sessionId", scope.row.sessionId)
            params.append("User_Type", scope.row.User_Type)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('158' + params)
            const { data: res } = await this.$http.post('/User/DisableUser', params)
            console.log(res)
            if (res.code != 1) {
                return this.$message.error('禁用失败！')
            } else {
                this.$message.success('禁用成功！')
            }
            this.getAllUserList()
            this.getAllUserList1()
        }

    }
}
</script>

<style lang="less" scoped>
.form {
  display: flex;
}
.btn {
  margin-left: 1%;
}
.button {
  width: 130%;
}
.twoform {
  display: flex;
}
</style>

